import { getRegion } from '../../../../components/regionWrapper';
import { Region } from '../../../../utils/commonInterfaces';
import { BRAND } from '../constants';
import { renderNa, renderAmount, renderColumnTitle, statusPillStyle } from '../utils';

// Builds the Transacting Users table columns. `onSuspend` opens the suspend modal for a user.
export const getUserColumns = (onSuspend: (id: string) => void): any[] => {
    const region = getRegion();
    return [
    {
        title: 'User ID',
        dataIndex: 'userID',
        key: 'userID',
        fixed: 'left' as const,
        render: renderNa,
    },
    {
        title: 'Company',
        dataIndex: 'companyName',
        key: 'companyName',
        fixed: 'left' as const,
        render: renderNa,
    },
    {
        title: 'Staff ID',
        dataIndex: 'staff_id',
        key: 'staff_id',
        fixed: 'left' as const,
        render: renderNa,
        },
        ...(region === Region.EG ? [{
            title: 'Bank Account Number',
            dataIndex: 'bankAccountNumber',
            key: 'bankAccountNumber',
            fixed: 'left' as const,
            render: renderNa,
        }] : []),
    {
        title: renderColumnTitle('Employee Name', 'اسم الموظف'),
        dataIndex: 'name',
        key: 'name',
        fixed: 'left' as const,
        render: renderNa,
    },
    {
        title: renderColumnTitle('National ID', 'رقم الهويه'),
        dataIndex: 'nationalID',
        key: 'nationalID',
        render: renderNa,
    },
    {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        render: (value: any) => {
            if (value === undefined || value === null || value === '') return 'N/A';
            const { bg, color } = statusPillStyle(value);
            return (
                <span style={{
                    display: 'inline-block', padding: '3px 12px', borderRadius: 999,
                    fontSize: 12, fontWeight: 600, background: bg, color,
                }}>
                    {value}
                </span>
            );
        },
    },
    {
        title: 'Suspension Flag',
        key: 'suspensionFlag',
        render: (_: any, record: any) => (
            <span style={{ fontWeight: 600, color: record?.isSuspended ? BRAND.greenDark : '#8fa3ae' }}>
                {record?.isSuspended ? 'Yes' : 'No'}
            </span>
        ),
    },
    {
        title: renderColumnTitle('Next Month Due Amount', 'المبلغ المستحق للشهر القادم'),
        dataIndex: 'nextMonthDueAmount',
        key: 'nextMonthDueAmount',
        render: renderAmount,
    },
        ...(region === Region.SE ? [{
        title: renderColumnTitle('Current Active Requests', 'الطلبات النشطة الحالية'),
        dataIndex: 'activeRequests',
        key: 'activeRequests',
        render: renderNa,
        }] : []),
    {
        title: renderColumnTitle('Remaining Outstanding Amounts', 'المبالغ المتبقية/المستحقة'),
        dataIndex: 'outstandingAmount',
        key: 'outstandingAmount',
        render: renderAmount,
    },
        ...(region === Region.SE ? [{
        title: renderColumnTitle('Remaining Installments (Months)', 'الأقساط المتبقية (بالأشهر)'),
        dataIndex: 'remainingInstallments',
        key: 'remainingInstallments',
        render: renderNa,
        }] : []),
    {
        title: renderColumnTitle('Total Requests Transferred', 'إجمالي الطلبات المحوّلة'),
        dataIndex: 'totalRequestsTransferred',
        key: 'totalRequestsTransferred',
        render: renderNa,
    },
    {
        title: renderColumnTitle(`Total Requested Amount (${region === Region.SE ? 'Including Cancelled & Processing' : 'Active Requests'} )`, `إجمالي المبلغ المطلوب (${region === Region.SE ? 'بما في ذلك الملغى وقيد المعالجة' : 'الطلبات النشطة'})`),
        dataIndex: 'totalRequestedAmountAllStatuses',
        key: 'totalRequestedAmountAllStatuses',
        render: renderAmount,
    },
    {
        title: renderColumnTitle('Total Requested Amount Transferred', 'إجمالي المبلغ المطلوب المحوّل'),
        dataIndex: 'totalRequestedAmountTransferred',
        key: 'totalRequestedAmountTransferred',
        render: renderAmount,
    },
        ...(region === Region.SE ? [{
        title: renderColumnTitle('Paid Amount', 'المبلغ المدفوع'),
        dataIndex: 'paidAmount',
        key: 'paidAmount',
        render: renderAmount,
        }] : []),
        ...(region === Region.SE ? [{
        title: renderColumnTitle('Requests Installments (Months)', 'عدد أقساط الطلب (بالأشهر)'),
        dataIndex: 'requestsInstallments',
        key: 'requestsInstallments',
        render: renderNa,
        }] : []),
    {
        title: 'Suspension Reason',
        dataIndex: 'suspensionReason',
        key: 'suspensionReason',
        render: (value: any, record: any) => record?.isSuspended && value ? value : 'N/A',
    },
        ...(region === Region.SE ? [{
        title: renderColumnTitle('Early Settlement Amount', 'مبلغ السداد المبكر'),
        dataIndex: 'earlySettlementAmount',
        key: 'earlySettlementAmount',
        render: renderAmount,
        }] : []),
        ...(region === Region.SE ? [{
        title: 'Suspend',
        dataIndex: 'block',
        key: 'block',
        align: 'center' as const,
        fixed: 'right' as const,
        width: 108,
        render: (_: any, row: any) => {
            if (row?.isSuspended) {
                return <span style={{ fontSize: 12, fontWeight: 600, color: '#9aa7ac' }}>Suspended</span>;
            }
            return (
                <button
                    type="button"
                    onClick={(e) => { e.stopPropagation(); onSuspend(row?.userID); }}
                    style={{
                        fontSize: 12,
                        fontWeight: 600,
                        color: '#fff',
                        cursor: 'pointer',
                        background: BRAND.tealDark,
                        border: 'none',
                        borderRadius: 8,
                        padding: '5px 16px',
                        transition: 'background 0.2s ease',
                    }}
                    onMouseEnter={(e) => { e.currentTarget.style.background = BRAND.teal; }}
                    onMouseLeave={(e) => { e.currentTarget.style.background = BRAND.tealDark; }}
                >
                    Suspend
                </button>
            );
        },
        }] : []),
];
}
